var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloudIconMemoryAiLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .memory-ai-cls-1 {\n        stroke-width: 2px;\n      }\n\n      .memory-ai-cls-1, .memory-ai-cls-2 {\n        fill: none;\n        stroke: currentColor;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n      }\n\n      .memory-ai-cls-2 {\n        stroke-width: 2.5px;\n      }\n\n      .memory-ai-cls-3, .memory-ai-cls-4, .memory-ai-cls-5 {\n        isolation: isolate;\n      }\n\n      .memory-ai-cls-4 {\n        font-size: 22.4px;\n      }\n\n      .memory-ai-cls-4, .memory-ai-cls-5 {\n        fill: currentColor;\n        stroke: none;\n        font-family: Tondo-Bold, Tondo;\n        font-weight: 700;\n      }\n\n      .memory-ai-cls-5 {\n        font-size: 6px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "memory-ai-cls-1",
    d: "M41.5,22h0c1.5-1.2,2.5-3,2.7-4.9s-.3-3.9-1.5-5.4c-1.4-1.8-3.5-2.8-5.7-2.8s-3.2.6-4.6,1.6h0c0-4.2-3.5-7.6-7.7-7.4-3.7.2-6.8,3.2-7,6.9v.5h0c-1.3-1-2.9-1.6-4.6-1.6s-4.3,1-5.7,2.8c-1.2,1.5-1.8,3.4-1.5,5.4.2,1.9,1.2,3.7,2.7,4.9h0c-3.9.9-6.4,4.8-5.5,8.8.8,3.3,3.7,5.7,7.1,5.7l1.6-.2h0c-.8,1.8-1,3.7-.3,5.6.6,1.8,2,3.3,3.7,4.2,1,.5,2.1.7,3.2.7,2.8,0,5.4-1.6,6.6-4.2h0c1.2,2.5,4.6,4.2,6.6,4.2s3.2-.7,3.2-.7c1.8-.8,3.1-2.3,3.7-4.2s.5-3.8-.3-5.6h0c.5,0,1.1.2,1.6.2,3.4,0,6.4-2.3,7.1-5.7.9-3.9-1.6-7.9-5.5-8.8h0Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "memory-ai-cls-3"
  }, /*#__PURE__*/React.createElement("g", {
    className: "memory-ai-cls-3"
  }, /*#__PURE__*/React.createElement("text", {
    className: "memory-ai-cls-4",
    transform: "translate(12.9 33.5)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "A")), /*#__PURE__*/React.createElement("text", {
    className: "memory-ai-cls-5",
    transform: "translate(27.3 33.5)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  })), /*#__PURE__*/React.createElement("text", {
    className: "memory-ai-cls-4",
    transform: "translate(28.8 33.5)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "I")))), /*#__PURE__*/React.createElement("line", {
    className: "memory-ai-cls-2",
    x1: 29.5,
    y1: 19,
    x2: 34.9,
    y2: 19
  }), /*#__PURE__*/React.createElement("line", {
    className: "memory-ai-cls-2",
    x1: 29.1,
    y1: 32.4,
    x2: 35,
    y2: 32.4
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudIconMemoryAiLine);
export default __webpack_public_path__ + "static/media/cloud_icon_memory_ai_line.80ba4c16cb9dceb41548a37a63453b90.svg";
export { ForwardRef as ReactComponent };